/** 도넛 바깥 지름. 고리 두께는 구멍과 26px를 유지한다. */
export const SHARE_RING = 176;
/** 흰 구멍. 합계 한 줄이 고리 위로 넘치지 않는 너비. */
export const SHARE_HOLE = 124;
/** 고리와 글자 사이 여백을 뺀 가용 너비. */
export const SHARE_CENTER_MAX = 108;

const SIZES = [20, 16, 13, 12, 11] as const;

export type ShareCenterPx = (typeof SIZES)[number];

/**
 * 고정폭 숫자 기준의 대략적인 em 너비.
 * 숫자 0.62, 쉼표·점·공백 0.28, 가운뎃점 0.5, 그 외(₩·한글) 0.95.
 */
export function shareCenterEm(text: string): number {
  let em = 0;
  for (const ch of text) {
    if (ch >= "0" && ch <= "9") em += 0.62;
    else if (ch === "," || ch === "." || ch === " ") em += 0.28;
    else if (ch === "•" || ch === "·") em += 0.5;
    else em += 0.95;
  }
  return em;
}

/** 구멍 안에 들어가는 가장 큰 글자 크기. 짧은 수는 20px. */
export function shareCenterPx(text: string, maxPx = SHARE_CENTER_MAX): ShareCenterPx {
  const em = shareCenterEm(text);
  for (const size of SIZES) {
    if (em * size <= maxPx) return size;
  }
  return 11;
}

/** 11px에서도 남으면 가운데 기준으로 줄여 끝자리가 잘리지 않게 한다. */
export function shareCenterScale(text: string, maxPx = SHARE_CENTER_MAX): number {
  const width = shareCenterEm(text) * 11;
  if (width <= maxPx || width === 0) return 1;
  return maxPx / width;
}
